export default {
  title: 'Criador de Planos IA',
  greeting: 'Olá! Estou aqui para ajudar você a criar uma Otimização de Plano. O que você precisa?',
  describeRequirements: 'Descreva seus requisitos',
  enterRequirements: 'Digite seus requisitos aqui...',
  next: 'Próximo'
}
